"use strict";

define('app/reporting/edit/audit.report.edit.view',['require','exports','module','rs/abstract.content.view','evisions/drag'],function (require, exports, module) {
  var AbstractContentView = require('rs/abstract.content.view');
  var EVIDrag = require('evisions/drag');
  var AuditReportEditView = AbstractContentView.extend({
    events: {
      'click .cancel-edit-report-btn': 'handleCancelReportBtnClick',
      'click .save-report-btn': 'handleSaveReportBtnClick',
      'click .save-run-report-btn': 'handleSaveRunReportBtnClick',
      'click .delete-report-btn': 'delegate.deleteCurrentReportDefinition',
      'click .save-new-report-btn': 'handleCreateReportBtnClick',
      'click .save-run-new-report-btn': 'handleCreateRunReportBtnClick',
      'click .rs-navigation-previous': 'handlePreviousNavigationBtnClick'
    },
    templates: {
      'audit.report.edit.init': 'renderInitFragment',
      'block.item': 'renderBlockFragment'
    },
    render: function render() {
      var delegate = this.getDelegate();
      this.$el.html(this.renderInitFragment(delegate.getTemplateProperties()));
      this.refreshSelectedFields();
      this.refreshEditMode();
      this.setRendered();
      this.$el.find('input').one('change', function () {
        delegate.setEditFlag();
      });
    },
    refresh: function refresh() {
      this.render();
      this.getDelegate().getReportPreviewTable().getView().setElement(this.getReportPreviewContainer());
      this.getDelegate().refreshReportPreview();
      this.renderFooter();
      this.resize();
    },
    refreshEditMode: function refreshEditMode() {
      var editable = this.getDelegate().isAbleToModifyReport(),
        mode = editable ? 'edit' : 'view';
      this.$('[data-mode]').hide();
      this.$('[data-mode="' + mode + '"]').show();
      if (editable) {
        this.refreshAvailableFields();
        this.enableReportFormFields();
      } else {
        this.disableReportFormFields();
      }
    },
    getAvailableColumnsContainer: function getAvailableColumnsContainer() {
      return this.$('.left-block-container');
    },
    getQueryColumnsContainer: function getQueryColumnsContainer() {
      return this.$('.right-block-container');
    },
    getReportPreviewContainer: function getReportPreviewContainer() {
      return this.$('.report-preview-container');
    },
    getFieldValues: function getFieldValues() {
      var data = {},
        fields = this.$('[data-validate]');
      fields.each(function () {
        var field = $(this),
          type = field.attr('type'),
          val = null;
        if (!type) {
          return;
        }
        switch (type) {
          case 'radio':
            val = field.prop('checked');
            break;
          default:
            val = field.val();
        }
        data[field.data('validate')] = val;
      });
      data.data = {
        columns: this.getSelectedColumns()
      };
      return data;
    },
    getSelectedColumns: function getSelectedColumns() {
      var blockElements = this.getQueryColumnsContainer().find('.block'),
        columns = [];
      for (var i = 0, len = blockElements.length; i < len; i++) {
        columns.push(this.getElementDatum(blockElements.get(i)));
      }
      return columns;
    },
    getPreviewColumnWidth: function getPreviewColumnWidth(size) {
      var calculateWidth = this.getReportPreviewContainer().width() / (size || 1),
        minWidth = 200;
      if (calculateWidth < minWidth) {
        calculateWidth = minWidth;
      }
      return calculateWidth + 'px';
    },
    handleCancelReportBtnClick: function handleCancelReportBtnClick(ev) {
      this.getDelegate().cancelReportEdit();
    },
    handleSaveReportBtnClick: function handleSaveReportBtnClick(ev) {
      var data = this.getFieldValues();
      this.getDelegate().requestSaveReportDefinition(data);
    },
    handleSaveRunReportBtnClick: function handleSaveRunReportBtnClick(ev) {
      var data = this.getFieldValues();
      this.getDelegate().requestSaveRunReportDefinition(data);
    },
    handleCreateReportBtnClick: function handleCreateReportBtnClick(ev) {
      var data = this.getFieldValues();
      this.getDelegate().requestCreateReportDefinition(data);
    },
    handleCreateRunReportBtnClick: function handleCreateRunReportBtnClick(ev) {
      var data = this.getFieldValues();
      this.getDelegate().requestCreateRunReportDefinition(data);
    },
    handlePreviousNavigationBtnClick: function handlePreviousNavigationBtnClick() {
      this.getDelegate().cancelReportEdit();
    },
    disableReportFormFields: function disableReportFormFields() {
      this.destroyDrag();
      this.getQueryColumnsContainer().addClass('disabled');
      this.$('input').prop('disabled', true);
    },
    enableReportFormFields: function enableReportFormFields(ev) {
      this.setupDrag();
      this.getQueryColumnsContainer().removeClass('disabled');
      this.$('input').prop('disabled', false);
    },
    setDragGhostPosition: function setDragGhostPosition(el) {
      var offset = this.get('container').offset(),
        elOffset = el.offset();
      return {
        top: elOffset.top - offset.top,
        left: elOffset.left - offset.left
      };
    },
    destroy: function destroy() {
      this.destroyDrag();
      this._super.apply(this, arguments);
    },
    destroyDrag: function destroyDrag() {
      if (this.drag_setup) {
        this._fieldsDrag.destroy();
        this.drag_setup = false;
      }
    },
    setupDrag: function setupDrag() {
      var that = this;
      if (this.drag_setup) {
        return;
      }
      this._fieldsDrag = EVIDrag.delegate(this.$el, '.block', {
        drag_min_distance: 5
      }).init(function (ev) {
        that._block = $(ev.currentTarget);
      }).plugin(EVIDrag.plugins.sortable).set('ghost', function (el) {
        return el.clone().addClass('ghost');
      }).set('placeholder', function () {
        var el = that._block;
        return $('<div/>').height(el.outerHeight()).width(el.outerWidth()).addClass(el.attr('class')).addClass('block-placeholder');
      }).set('sortableElements', function () {
        return that.$('.block').filter(':visible');
      }).set('sortableElement', function (el) {
        return el;
      }).end(function () {
        this._draggedAnObject = true;
      }).release(function (el) {
        var blockEl = that._block,
          data = null;
        if (!this._draggedAnObject) {
          return;
        }
        this._draggedAnObject = false;
        if (blockEl && blockEl.closest('.left-block-container').get(0)) {
          that.returnToAvailableColumns(blockEl);
          that._block = null;
        } else if (blockEl && blockEl.closest('.right-block-container').get(0)) {
          that.getDelegate().setEditFlag();
          data = that.getElementDatum(blockEl);
          that.getDelegate().addReportColumn(data);
        }
        _.defer(function () {
          that.getDelegate().refreshReportPreview();
        });
      });
      this._fieldsDrag.delegateDrop('.right-block-container').enter(function (el) {
        var placeholder = that._fieldsDrag.get('placeholder'),
          list = that.$(this.selector).find('.list-group');
        if (placeholder && placeholder.closest('.left-block-container').get(0)) {
          placeholder.remove();
          list.append(placeholder);
        }
      });
      this._fieldsDrag.delegateDrop('.left-block-container').enter(function (el) {
        el.find('.drop-overlay').show();
      }).exit(function (el) {
        el.find('.drop-overlay').hide();
      }).drop(function (el) {
        if (that._block) {
          that.returnToAvailableColumns(that._block);
        }
      });
      this.drag_setup = true;
    },
    returnToAvailableColumns: function returnToAvailableColumns(el) {
      var data = this.getElementDatum(el);
      this.getDelegate().removeReportColumn(data);
      el.remove();
      this.refreshAvailableFields();
      this.switchColumnTypeTab(data);
    },
    refreshAvailableFields: function refreshAvailableFields() {
      var fields = this.getDelegate().getAvailableColumns(),
        fieldGroups = {};
      fields = _.sortBy(fields, function (field) {
        return field.displayName;
      });
      fieldGroups = _.groupBy(fields, function (field) {
        return String(field.type.name).toLowerCase();
      });
      this.renderBlocks(this.$('#study-report-fields'), fieldGroups['study']);
      this.renderBlocks(this.$('#audit-report-fields'), fieldGroups['audit']);
    },
    renderBlocks: function renderBlocks(container, items) {
      var list = container.find('.list-group');
      if (items && items.length) {
        list.html(this.renderBlockFragment(items, true));
      } else {
        list.html('');
      }
    },
    refreshSelectedFields: function refreshSelectedFields() {
      var container = this.getQueryColumnsContainer().find('.list-group'),
        report = this.getDelegate().getReport(),
        fields = report && report.data ? report.data.columns : null,
        fragment = null;
      fragment = this.renderBlockFragment(fields || [], true);
      container.html(fragment);
    },
    highlightColumn: function highlightColumn(column) {
      var el = $('[data-field="' + column.name + '"]'),
        counter = 1,
        highlight = null;
      highlight = setInterval(function () {
        var width = Math.ceil(parseFloat(el.css('outline-width')));
        if (counter == 5) {
          el.css('outline-width', 0);
          clearInterval(highlight);
        }
        if (width && counter % 2 != 0) {
          el.css('outline-width', 0);
        } else {
          el.css('outline', '1px solid #FEAE23');
          counter++;
        }
      }, 150);
    },
    switchColumnTypeTab: function switchColumnTypeTab(column) {
      var tabPane = '#' + String(column.type.description).toLowerCase() + '-report-fields',
        that = this;
      if (!$(tabPane).hasClass('active')) {
        $('.nav-tabs a[href="' + tabPane + '"]').tab('show');
      }
    },
    resize: function resize() {
      var delegate = this.getDelegate();
      this._super.apply(this, arguments);
      if (delegate.getReportPreviewTable().hasStarted()) {
        this.getDelegate().refreshReportPreview();
      }
    },
    resizePreviewTable: function resizePreviewTable() {
      var table = this.getReportPreviewContainer(),
        delegate = this.getDelegate(),
        tableWidth = table.width();
      if (delegate.getReportPreviewTable().hasStarted()) {
        table.find('.e3-table-header').width(tableWidth);
        table.find('.e3-table-row-container').width(tableWidth);
      }
    }
  });
  module.exports = AuditReportEditView;
});

